export const INDUSTRIES = [
  'Technology',
  'Healthcare',
  'Finance & Banking',
  'Education',
  'Manufacturing',
  'Retail & E-commerce',
  'Hospitality & Tourism',
  'Construction & Real Estate',
  'Logistics & Transportation',
  'Professional Services',
  'Media & Entertainment',
  'Non-profit',
  'Government',
  'Agriculture',
  'Energy & Utilities',
  'Other'
]

export const COMPANY_SIZES = ['1-10', '11-50', '51-200', '201-500', '501-1000', '1000+']

export const inputClass =
  'w-full rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm transition-all placeholder:text-slate-400 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20'

export const labelClass = 'mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500'

export const needsEmployerOnboarding = (company) => {
  if (!company) return true
  if (company.onboardingComplete) return false
  const hasDescription = Boolean((company.description || '').trim())
  const hasRealIndustry = Boolean((company.industry || '').trim()) && company.industry !== 'General'
  return !hasDescription || !hasRealIndustry
}

export const companyToFormState = (company, user) => ({
  name: company?.name || '',
  industry: company?.industry === 'General' ? '' : (company?.industry || ''),
  size: company?.size || '1-10',
  website: company?.website || '',
  description: company?.description || '',
  contactPersonName:
    company?.contactPersonName || `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
  contactPersonRole: company?.contactPersonRole || 'HR',
  contactEmail: company?.contactEmail || user?.email || '',
  contactPhone: company?.contactPhone || user?.phoneNumber || '',
  location: {
    country: company?.location?.country || '',
    state: company?.location?.state || '',
    city: company?.location?.city || '',
    addressLine: company?.location?.addressLine || ''
  }
})

export const formToCompanyPayload = (form, { complete = false } = {}) => ({
  name: form.name.trim(),
  industry: form.industry.trim() || 'General',
  size: form.size,
  website: form.website.trim(),
  description: form.description.trim(),
  contactPersonName: form.contactPersonName.trim(),
  contactPersonRole: form.contactPersonRole.trim(),
  contactEmail: form.contactEmail.trim(),
  contactPhone: form.contactPhone.trim(),
  location: {
    country: form.location.country.trim(),
    state: form.location.state.trim(),
    city: form.location.city.trim(),
    addressLine: form.location.addressLine.trim()
  },
  ...(complete ? { onboardingComplete: true } : {})
})
